import { render, staticRenderFns } from "./regionalFees.vue?vue&type=template&id=79874818"
import script from "./regionalFees.vue?vue&type=script&lang=js"
export * from "./regionalFees.vue?vue&type=script&lang=js"
import style0 from "./regionalFees.vue?vue&type=style&index=0&id=79874818&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports